import { InjectionToken } from '@angular/core';

export const APP_INSIGHTS_CONFIG = new InjectionToken<string>('APP_INSIGHTS_CONFIG');
